import { BaseEntityPage } from '../../components/common';
import { THPTContent } from './components';

export default function THPTPage() {
	const PAGE_PADDING = { xs: 1.5, sm: 2, md: 3 };
	return (
		<BaseEntityPage
			ContentComponent={THPTContent}
			sx={{ p: PAGE_PADDING }}
		/>
	);
}